var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessDeposit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4305_78988)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#02BD9C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24zm0-2c12.15 0 22-9.85 22-22S36.15 2 24 2 2 11.85 2 24s9.85 22 22 22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.218 33.625l-8-8a1.003 1.003 0 01.158-1.408 1.005 1.005 0 011.406.158l7.208 7.008 13.22-16.998c.34-.434.968-.514 1.404-.176.436.338.514.968.176 1.404l-14 18a.999.999 0 01-.784.386 1.01 1.01 0 01-.788-.374z",
    stroke: "#02BD9C",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4305_78988"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })))));
}
SvgSuccessDeposit.displayName = 'SuccessDeposit';
export default SvgSuccessDeposit;